export default __webpack_public_path__ + "static/media/1415 utensils top.531c11d2.png";